module.exports = __webpack_public_path__ + "img/ring_y_o_0_null@3x.dfb39f6a.png";